// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cortona3dsolo-svg {\n    width: 100%;\n    height: 100%;\n    display: block;\n    position: absolute;\n}\n\n.cortona3dsolo-svg .recognized-aps:hover {\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n\n.cortona3dsolo-svg .recognized-aps-region {\n    opacity: 1;\n}\n\n.cortona3dsolo-svg .recognized-aps-region,\n.cortona3dsolo-svg .recognized-aps[name] path.hover, \n.cortona3dsolo-svg .recognized-aps[name] path.select {\n    vector-effect: non-scaling-stroke;\n}", ""]);
// Exports
module.exports = exports;
